
    import {Component, Prop, Vue} from 'vue-property-decorator'
    import {getMerchantsGroupList, GroupListDto} from "@/api/customerManage";

    @Component({
        name: 'GroupFilters'
    })
    export default class GroupFilters extends Vue {
        @Prop({default: true}) isShowAll!: boolean // 是否显示所有分组
        @Prop({default: true}) isShowReset!: boolean // 是否显示清空
        @Prop({default: false}) isShowAdd!: boolean // 是否直接显示新增按钮
        @Prop({default: true}) isShowSetting!: boolean // 是否直接显示设置按钮
        @Prop({default: '客户分组筛选'}) title!: boolean // 标题
        @Prop({default: false}) isShop!: boolean // 是否是企业商城的设置

        showTemp = false
        companyId = ''
        groupList: GroupListDto[] = []
        groupId = ''

        mounted () {
            this.$eventBus.$on('groupAdd', (res: string) => {
                this.getGroupList().then(()=>{
                  this.groupId = res
                  this.showTemp = false
                  this.sureFunc()
                })
            })
        }

        getGroupList () {
            return  getMerchantsGroupList({companyId: this.companyId}).then((res) => {
                this.groupList = res.data.groupList || []
            })
        }

        show (options: { companyId: string, groupId: string }) {
            this.companyId = options.companyId
            this.groupId = options.groupId
            this.getGroupList()
            this.showTemp = true
        }

        hide () {
            this.showTemp = false
        }

        sureFunc () {
            const data = this.groupList.filter(item => { return item.groupId === this.groupId })
            this.$emit('getGroupId', this.groupId, data && data.length > 0 ? data[0] : {groupId: '',
              groupName: ''})
            this.hide()
        }

        resetFunc () {
            this.groupId = ''
            this.$emit('getGroupId', this.groupId, {
              groupId: '',
              groupName: ''
            })
            this.hide()
        }

        changeTag (id: string) {
           this.groupId = id
        }

        toSetting () {
            this.hide()
            this.$nextTick(() => {
                if(this.isShop){
                  this.$router.push('/shopGroupSetting')
                }else{
                  this.$router.push('/groupSetting')
                }
            })
        }

        toAdd () {
            this.showTemp = false
            this.$router.push({
                path: '/groupHandle',
                query: {
                    isAdd: '1'
                }
            })
        }

        destroyed () {
            this.$eventBus.$off('groupAdd')
        }
    }
